// extracted by mini-css-extract-plugin
export default {"root":"PriceFilterPopup_root__14lwx"};